<template>
  <div class="pa-4">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn outlined elevation="0" color="primary" small
        @click="newUserDialog = true; newUser = { nationality: academyCountry }">
        <v-icon class="mr-1" size="20">mdi-account-plus-outline</v-icon>
        <span v-if="!isSmallerDisplay()">{{ $t("message.add_member") }}</span>
      </v-btn>
      <v-btn outlined elevation="0" color="primary" small @click="inviteMemberDialog = true;">
        <v-icon size="20">mdi-link</v-icon>
        <span v-if="!isSmallerDisplay()">{{ $t("message.invite_members") }}</span>
      </v-btn>
      <v-menu elevation="0" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <v-badge class="mr-2" v-if="upcomingBirthdays" bordered color="accent" icon="mdi-cake-variant-outline"
              overlap>
              <v-btn class="ml-1" outlined elevation="0" color="primary" bottom>
                <v-icon size="20" class="mr-1">mdi-dots-vertical</v-icon>
              </v-btn>
            </v-badge>
            <v-btn v-else class="ml-1" outlined elevation="0" color="primary" bottom>
              <v-icon size="20" class="mr-1">mdi-dots-vertical</v-icon>
            </v-btn>
          </span>
        </template>
        <v-list>
          <v-list-item v-if="messagesThread" @click="goToMessagesThread()">
            <v-list-item-title class="clickable">
              <v-icon class="mr-1">mdi-chat-processing-outline</v-icon>
              <span>{{ $t("message.go_to_messsages_thread")
                }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-else @click="initMessagesThreadDialog = true;">
            <v-list-item-title class="clickable">
              <v-icon class="mr-1">mdi-chat-processing-outline</v-icon>
              <span>{{ $t("message.init_academy_messages")
                }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'advancedusersearch' })">
            <v-list-item-title class="clickable">
              <v-icon class="mr-1">mdi-filter-multiple-outline</v-icon>
              <span>{{ $t("message.advanced_search")
                }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="upcomingBirthdaysDialog = true">
            <v-list-item-title class="clickable">
              <v-icon :color="upcomingBirthdays ? 'accent' : ''" class="mr-1">mdi-cake-variant-outline</v-icon>
              <span>{{ $t("message.upcoming_birthdays")
                }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!isSmallerDisplay()" @click="getMembersCSV()">
            <v-list-item-title class="clickable">
              <v-icon class="mr-1">mdi-cloud-download-outline</v-icon>
              <span>{{ $t("message.download_list")
                }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-actions>
    <div>
      <v-tabs v-model="activeTab" show-arrows>
        <v-tab :key="'members'" ripple @click="clickTab(0)">{{ $t("message.members") }} ({{ members.length }})</v-tab>
        <v-tab :key="'pending_approval'" ripple @click="clickTab(1)">{{ $t("message.pending_approval") }} ({{
          pending.length }})
        </v-tab>
        <v-tab :key="'rejected'" ripple @click="clickTab(2)">{{ $t("message.alumni") }}
          ({{ rejected.length }})</v-tab>

        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="'members'">
            <v-card elevation="0" class="mb-3 mt-1">
              <v-card-text v-if="!isSmallerDisplay()" class="pa-0 mb-1 pb-1">
                <v-row>
                  <v-col class="pb-0" cols="12" sm="12" md="6">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_table')"
                      v-model="filterTableValue">
                    </v-text-field>
                  </v-col>
                  <v-col class="pb-0" cols="12" sm="12" md="6">
                    <tags-select v-if="availableTags" v-model="tagFilter" :label="$t('message.filter_table_label')"
                      :items="availableTags"></tags-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-0" cols="12" sm="12" md="4">
                    <v-select :label="$t('message.member_type')" :hide-details="true" item-text="text"
                      item-value="value" outlined dense :items="memberTypes" v-model="minorsFilter"></v-select>
                  </v-col>
                  <v-col class="pb-0" cols="12" sm="12" md="4">
                    <v-select :label="$t('message.membership_status')" :hide-details="true" item-text="text"
                      item-value="value" outlined dense :items="statusTypes" v-model="statusFilter"></v-select>
                  </v-col>
                  <v-col class="pb-0" cols="12" sm="12" md="4">
                    <v-select clearable :label="$t('message.membership_type')" :hide-details="true" item-text="text"
                      item-value="value" outlined dense :items="membershipTypes"
                      v-model="membershipTypeFilter"></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else class="pa-0 mb-2">
                <v-row>
                  <v-col class="pb-0">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_table')"
                      v-model="filterTableValue">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions class="pr-0 mr-0">
                  <v-spacer></v-spacer>
                  <v-btn @click="displayFilters = !displayFilters" elevation="0" text color="primary" x-small>{{
                    !displayFilters ? $t('message.more_filters') : $t('message.hide_filters') }}</v-btn>
                </v-card-actions>
                <v-row v-if="displayFilters">
                  <v-col class="pb-0" cols="12" sm="12" md="3">
                    <tags-select v-if="availableTags" v-model="tagFilter" :label="$t('message.filter_table_label')"
                      :items="availableTags"></tags-select>
                  </v-col>
                  <v-col class="pb-0" cols="12" sm="12" md="3">
                    <v-select :label="$t('message.member_type')" :hide-details="true" item-text="text"
                      item-value="value" outlined dense :items="memberTypes" v-model="minorsFilter"></v-select>
                  </v-col>
                  <v-col class="pb-0" cols="12" sm="12" md="3">
                    <v-select :label="$t('message.membership_status')" :hide-details="true" item-text="text"
                      item-value="value" outlined dense :items="statusTypes" v-model="statusFilter"></v-select>
                  </v-col>
                  <v-col class="pb-0" cols="12" sm="12" md="3">
                    <v-select clearable :label="$t('message.membership_type')" :hide-details="true" item-text="text"
                      item-value="value" outlined dense :items="membershipTypes"
                      v-model="membershipTypeFilter"></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-menu elevation="0" offset-y :disabled="selectedItems.length == 0">
                      <template v-slot:activator="{ on }">
                        <v-btn outlined small elevation="0" :disabled="selectedItems.length == 0"
                          :block="isSmallerDisplay()" color="primary" v-on="on" slot="activator" bottom>
                          <v-icon size="20" class="mr-1">mdi-dots-vertical</v-icon>
                          {{ $t("message.actions") }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title v-if="activeTab == 0 || activeTab == 4" @click="openSendEmailDialog()"
                            class="clickable">
                            <v-icon class="mr-1">mdi-email-fast-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{ $t("message.send_emails")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0">
                          <v-list-item-title @click="openSendNotiDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-cellphone</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.send_notifications")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0">
                          <v-list-item-title @click="openTagsDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-tag-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.add_labels")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0" v-allowed="'send_waiver'">
                          <v-list-item-title @click="openSendDocuDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-text-box-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.send_document")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0" v-allowed="'manage_syllabus_instances'">
                          <v-list-item-title @click="openAssignSyllabusDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-school-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.assign_syllabus")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0 && availableCheckinClasses">
                          <v-list-item-title @click="openBulkCheckinDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-map-marker-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.bulk_checkin")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mt-1" v-if="!isSmallerDisplay()" elevation="0" outlined>
              <v-data-table class="elevation-0 mt-1" outlined v-model="selectedItems" item-key="_id" :headers="headers"
                show-select :custom-sort="membersSort" :loading="loading" :loading-text="$t('message.loading')"
                :items="filteredMembers" :no-data-text="$t('message.no_data')" :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75, -1],
                }">
                <template v-slot:top>
                  <div class="text-caption ml-2 pl-2">
                    <v-row>
                      <v-col>
                        <v-icon class="mr-1" size="15">mdi-cash-multiple</v-icon><span>{{ $t("message.paying_members")
                        }}</span>:
                        <v-progress-circular size="15" v-if="loading" :width="2" indeterminate></v-progress-circular>
                        <span v-else class="text-subtitle-1">{{ payingMembers }}</span></v-col>
                      <v-col>
                        <v-icon class="mr-1" size="15">mdi-currency-usd-off</v-icon><span>{{
                          $t("message.free_memberships")
                        }}</span>:
                        <v-progress-circular size="15" v-if="loading" :width="2" indeterminate></v-progress-circular>
                        <span v-else class="text-subtitle-1">{{ freeMembers }}</span></v-col>
                      <v-col>
                        <v-icon class="mr-1" size="15">mdi-block-helper</v-icon><span>{{ $t("message.no_membership")
                          }}</span>:
                        <v-progress-circular size="15" v-if="loading" :width="2" indeterminate></v-progress-circular>
                        <span v-else class="text-subtitle-1">{{ noMembershipMembers }}</span></v-col>
                    </v-row>
                  </div>
                  <v-card-actions class="ml-2 pl-2 mb-0 pb-0 mt-0 pt-0">
                    <v-checkbox hide-details
                      :label="$t('message.select_all') + ' (' + $t('message.members_selected', [selectedItems.length + '/' + filteredMembers.length]) + ')'"
                      @change="selectAll()"></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-menu elevation="0" offset-y :disabled="selectedItems.length == 0">
                      <template v-slot:activator="{ on }">
                        <v-btn outlined elevation="0" :disabled="selectedItems.length == 0" :block="isSmallerDisplay()"
                          color="primary" v-on="on" slot="activator" bottom>
                          <v-icon size="20" class="mr-1">mdi-dots-vertical</v-icon>
                          {{ $t("message.actions") }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title v-if="activeTab == 0 || activeTab == 4" @click="openSendEmailDialog()"
                            class="clickable">
                            <v-icon class="mr-1">mdi-email-fast-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{ $t("message.send_emails")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0">
                          <v-list-item-title @click="openSendNotiDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-cellphone</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.send_notifications")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0">
                          <v-list-item-title @click="openTagsDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-label-multiple-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.update_labels")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0" v-allowed="'send_waiver'">
                          <v-list-item-title @click="openSendDocuDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-text-box-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.send_document")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0" v-allowed="'manage_syllabus_instances'">
                          <v-list-item-title @click="openAssignSyllabusDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-school-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.assign_syllabus")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="activeTab == 0 && availableCheckinClasses">
                          <v-list-item-title @click="openBulkCheckinDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-map-marker-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                              $t("message.bulk_checkin")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.avatar="{ item }">
                  <div class="text-xs-center clickable" @click="viewMember(item._id, null, null, item.displayName)">
                    <member-avatar :image="item.userImageSmall
                      ? item.userImageSmall
                      : item.userImage
                      " size="40"></member-avatar>
                  </div>
                </template>
                <template v-slot:item.displayName="{ item }">
                  <div @click="viewMember(item._id, null, null, item.displayName)">
                    {{ item.displayName }}
                    <country-display class="ml-1 mr-1" :country-code="item.nationality" />
                    <v-tooltip top v-if="item.isMinor">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="accent">mdi-baby-face-outline</v-icon>
                      </template>
                      <span>{{ $t("message.is_minor") }}</span>
                    </v-tooltip>
                    <v-tooltip top v-else-if="item.notBjjUser">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="accent">mdi-account-remove-outline</v-icon>
                      </template>
                      <span>{{ $t("message.not_bjj_user") }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="item.isBirthday">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="accent">mdi-cake-variant-outline</v-icon>
                      </template>
                      <span>{{ $t("message.is_birthday") }}</span>
                    </v-tooltip>
                    <v-badge color="secondary" v-else-if="item.daysUntilBirthDate < 0"
                      :content="item.daysUntilBirthDate" overlap>
                      <v-icon color="accent">mdi-cake-variant-outline</v-icon>
                    </v-badge>
                  </div>
                </template>
                <template v-slot:item.joined="{ item }">{{
                  item.joined ? $d(new Date(item.joined), "month_day_year", $i18n.locale) : ''
                  }}</template>
                <template v-slot:item.dob="{ item }">{{
                  item.dob ? $d(dateFromStringInTZ(item.dob), "month_day_year", $i18n.locale) : ''
                  }}</template>
                <template v-slot:item.lastPaymentStatus="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-if="item.lastPaymentStatusData" v-bind="attrs" v-on="on">
                        <v-badge v-if="item.lastPaymentStatusData.status == 'pending_payment'" small overlap
                          icon="mdi-email-fast-outline" color="accent">
                          <v-btn @click="goToTransaction(item.lastPaymentStatusData.transaction)" icon>
                            <v-icon :color="getStatusColor(item.lastPaymentStatusData.status)">{{ item.transactionIcon
                              }}
                            </v-icon>
                          </v-btn>
                        </v-badge>
                        <v-badge v-else-if="item.lastPaymentStatusData.recurrent" small overlap icon="mdi-sync"
                          color="accent">
                          <v-btn @click="goToTransaction(item.lastPaymentStatusData.transaction)" icon>
                            <v-icon :color="getStatusColor(item.lastPaymentStatusData.status)">{{ item.transactionIcon
                              }}
                            </v-icon>
                          </v-btn>
                        </v-badge>
                        <v-btn v-else @click="goToTransaction(item.lastPaymentStatusData.transaction)" icon>
                          <v-icon :color="getStatusColor(item.lastPaymentStatusData.status)">{{ item.transactionIcon }}
                          </v-icon>
                        </v-btn>
                      </div>
                      <v-btn v-bind="attrs" v-on="on" v-else text icon @click="goToSellMembership(item)">
                        <v-icon>mdi-ticket-confirmation-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.lastPaymentStatus ? (item.freeMembership ? $t("message.free_membership") :
                      getSubscriptionStatusText(item.lastPaymentStatusData.status)) :
                      $t("message.sell_membership")
                      }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.curriculumProgress="{ item }">
                  <v-btn small icon v-if="!item.hasCurriculum && item.notBjjUser"
                    @click="viewMember(item._id, null, 'lms', item.displayName)">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-school-outline</v-icon>
                      </template>
                      <span>{{ $t('message.no_syllabus_assigned') }}</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn small icon v-else-if="!item.hasCurriculum"
                    @click="viewMember(item._id, null, 'lms', item.displayName)">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <belt-display v-bind="attrs" v-on="on" :belt="item.belt" :show-text="false" />
                      </template>
                      <span>{{ $t('message.no_syllabus_assigned') }}</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn v-else-if="item.curriculumData" small icon
                    @click="viewMember(item._id, item.curriculumData.instanceId, null, item.displayName)">
                    <v-progress-circular v-if="item.curriculumData.useBelts && item.curriculumData.level" class="mt-1"
                      size="30" :value="item.curriculumData.progress" :color="getColor(item.curriculumData.level)">
                      <span :class="'text-caption ' + getProgressTextColor(item.curriculumData.level) + '--text'">{{
                        item.curriculumData.progress
                      }}</span>
                    </v-progress-circular>
                    <v-progress-circular v-else class="mt-1" size="30" :value="item.curriculumData.progress"
                      :color="item.curriculumData.useBelts && item.belt ? getColor(item.belt) : 'accent'">
                      <span :class="'text-caption ' + getProgressTextColor(item.curriculumData.level) + '--text'">{{
                        item.curriculumData.progress
                      }}</span>
                    </v-progress-circular>
                  </v-btn>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" @click="displayPhoneDialog(item)" icon>
                        <v-icon v-if="item.hasApp" color="primary">mdi-cellphone-arrow-down</v-icon>
                        <v-icon v-else color="gray">mdi-cellphone-remove</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.hasApp ? item.hasApp.deviceName : $t("message.no_app") }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" @click="displayPhoneDialog(item)" icon>
                        <v-icon v-if="item.phone" color="primary">mdi-phone-check</v-icon>
                        <v-icon v-else color="gray">mdi-phone-cancel-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.phone ? item.phone : $t("message.no_data") }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" @click="displaySocialPostDialog(item)" :disabled="item.isMinor"
                        icon>
                        <v-icon color="gray">mdi-bullhorn-variant-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("message.member_shoutout") }}</span>
                  </v-tooltip>
                  <v-btn v-if="!hideCheckinCodes" @click="viewUserCode(item)" icon>
                    <v-icon v-if="item.code" color="primary">mdi-fingerprint</v-icon>
                    <v-icon v-else>mdi-fingerprint-off</v-icon>
                  </v-btn>
                  <v-btn @click="viewMember(item._id, null, 'alerts', item.displayName)" icon>
                    <v-badge v-if="item.alerts > 0" color="error" :content="item.alerts" overlap small>
                      <v-icon>mdi-bell-outline</v-icon>
                    </v-badge>
                    <v-icon v-else>mdi-bell-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
            <v-card v-else class="mt-2" elevation="0" outlined>
              <v-skeleton-loader v-if="loadingMembers" type="list-item-avatar"></v-skeleton-loader>
              <v-card-actions v-else class="ml-2 pl-2 mb-1 pb-0">
                <v-checkbox class="mt-0 pt-0" hide-details :label="$t('message.select_all')"
                  @change="selectAll()"></v-checkbox>
                <v-spacer></v-spacer>
                <span class="supporting-text ml-1">
                  {{ $t('message.members_selected', [selectedItems.length + '/' + filteredMembers.length]) }}
                </span>
              </v-card-actions>
              <v-card-text class="text-center">
                <v-row>
                  <v-col>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-icon class="mr-1" size="15">mdi-cash-multiple</v-icon>
                          <v-progress-circular size="15" v-if="loading" :width="2" indeterminate></v-progress-circular>
                          <span v-else class="text-subtitle-1">{{ payingMembers }}</span>
                        </div>
                      </template>
                      <span>{{ $t("message.paying_members") }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-icon class="mr-1" size="15">mdi-currency-usd-off</v-icon>
                          <v-progress-circular size="15" v-if="loading" :width="2" indeterminate></v-progress-circular>
                          <span v-else class="text-subtitle-1">{{ freeMembers }}</span>
                        </div>
                      </template>
                      <span>{{ $t("message.free_memberships") }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-icon class="mr-1" size="15">mdi-block-helper</v-icon>
                          <v-progress-circular size="15" v-if="loading" :width="2" indeterminate></v-progress-circular>
                          <span v-else class="text-subtitle-1">{{ noMembershipMembers }}</span>
                        </div>
                      </template>
                      <span>{{ $t("message.no_membership") }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-list v-if="filteredMembers && filteredMembers.length > 0">
                <template v-for="(m, index) in filteredMembers">
                  <v-list-item :key="'member_' + index + '_' + m._id">
                    <v-list-item-action>
                      <v-checkbox v-model="selectedItems" :value="m" primary hide-details></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-avatar @click="viewMember(m._id, null, null, m.displayName)">
                      <member-avatar v-if="!m.hasCurriculum" :status="m.lastPaymentStatus" :image="m.userImageSmall ? m.userImageSmall : m.userImage
                        " size="40"></member-avatar>
                      <v-progress-circular v-else-if="m.curriculumData" class="mt-1" width="15" size="50"
                        :value="m.curriculumData.progress"
                        :color="m.curriculumData.useBelts && m.belt ? getColor(m.belt) : 'accent'">
                        <MemberAvatar :status="m.lastPaymentStatus"
                          :image="m.userImageSmall ? m.userImageSmall : m.userImage" size="30"></MemberAvatar>
                      </v-progress-circular>
                    </v-list-item-avatar>
                    <v-list-item-content class="text-left" @click="viewMember(m._id, null, null, m.displayName)">
                      <v-list-item-title style="margin-left: 10px">
                        <v-tooltip v-if="m.isBirthday" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="accent" size="20">mdi-cake-variant-outline</v-icon>
                          </template>
                          <span>{{ $t("message.is_birthday") }}</span>
                        </v-tooltip>
                        <v-badge v-else-if="m.daysUntilBirthDate < 0" color="accent" :content="m.daysUntilBirthDate"
                          overlap>
                          <v-icon color="accent">mdi-cake-variant-outline</v-icon>
                        </v-badge>
                        <v-tooltip top v-if="m.isMinor">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20" color="accent">mdi-baby-face-outline</v-icon>
                          </template>
                          <span>{{ $t("message.is_minor") }}</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="m.notBjjUser">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20"
                              color="terciary">mdi-account-remove-outline</v-icon>
                          </template>
                          <span>{{ $t("message.not_bjj_user") }}</span>
                        </v-tooltip>
                        {{ m.displayName }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon color="gray" small slot="activator" left>
                            <v-badge v-if="m.alerts > 0" v-on="on" color="error" dot overlap small>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-badge>
                            <v-icon v-else>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title @click="m.whatsapp ? displayPhoneDialog(m) : copyPhone(m.phone)">
                              <v-icon v-if="m.phone" color="primary">mdi-phone-check</v-icon>
                              <v-icon v-else>mdi-phone-cancel-outline</v-icon>
                              <span class="ml-2">{{ $t('message.phone') }}</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon v-if="m.hasApp" color="primary">mdi-cellphone-arrow-down</v-icon>
                              <v-icon v-else>mdi-cellphone-remove</v-icon>
                              <span v-if="m.hasApp" class="ml-2">{{ m.hasApp.deviceName }}</span>
                              <span v-else class="ml-2">{{ $t('message.no_app') }}</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title v-if="m.lastPaymentStatusData"
                              @click="goToTransaction(m.lastPaymentStatusData.transaction)">
                              <v-badge v-if="m.lastPaymentStatusData.status == 'pending_payment'" small overlap
                                icon="mdi-email-fast-outline" color="accent">
                                <v-icon :color="getStatusColor(m.lastPaymentStatusData.status)">{{ m.transactionIcon }}
                                </v-icon>
                              </v-badge>
                              <v-badge v-else-if="m.lastPaymentStatusData.recurrent" small overlap icon="mdi-sync"
                                color="accent">
                                <v-icon :color="getStatusColor(m.lastPaymentStatusData.status)">{{ m.transactionIcon }}
                                </v-icon>
                              </v-badge>
                              <v-icon v-else :color="getStatusColor(m.lastPaymentStatusData.status)">{{
                                m.transactionIcon }}
                              </v-icon>
                              <span class="ml-2">{{ $t('message.transaction') }}</span>
                            </v-list-item-title>
                            <v-list-item-title v-else @click="goToSellMembership(m)">
                              <v-icon>mdi-ticket-confirmation-outline</v-icon>
                              <span class="ml-2">{{ $t('message.sell_membership') }}</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!hideCheckinCodes" @click.stop="viewUserCode(m)">
                            <v-list-item-title>
                              <v-icon v-if="m.code" color="primary">mdi-fingerprint</v-icon>
                              <v-icon v-else>mdi-fingerprint-off</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click.stop="displaySocialPostDialog(m)" v-if="!m.isMinor">
                            <v-list-item-title>
                              <v-icon color="gray">mdi-bullhorn-variant-outline</v-icon>
                              <span class="ml-2">{{
                                $t('message.member_shoutout') }}</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click.stop="viewMember(m._id, m.curriculumData.instanceId, null, m.displayName)"
                            v-if="m.curriculumData">
                            <v-list-item-title>
                              <v-progress-circular class="mt-1" size="30" :value="m.curriculumData.progress"
                                :color="m.belt ? getColor(m.belt) : 'primary'">
                                <span class="text-caption">{{ m.curriculumData.progress }}</span>
                              </v-progress-circular>
                              <span class="ml-2">{{ $t('message.progress') }}</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="m.alerts > 0" @click="viewMember(m._id, null, 'alerts', m.displayName)">
                            <v-list-item-title>
                              <v-badge color="error" :content="m.alerts" overlap small>
                                <v-icon color="primary">mdi-bell-outline</v-icon>
                              </v-badge>
                              <span class="ml-2">{{ $t('message.alerts') }}</span>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < filteredMembers.length" :key="'members_index_' + index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="'pending_approval'">
            <v-card v-if="!isSmallerDisplay()">
              <v-data-table outlined v-model="selectedItems" item-key="_id" :headers="headersPending" :items="pending"
                class="elevation-1" :no-data-text="$t('message.no_data')" :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.avatar="{ item }">
                  <div class="text-xs-center clickable" @click="goToMember(item._id, item.displayName)">
                    <member-avatar :image="item.userImageSmall
                      ? item.userImageSmall
                      : item.userImage
                      " size="40"></member-avatar>
                  </div>
                </template>
                <template v-slot:item.displayName="{ item }">
                  <span class="mr-1">{{ item.displayName }}</span>
                  <country-display :country-code="item.nationality" />
                </template>
                <template v-slot:item.belt="{ item }">
                  <belt-display :belt="item.belt" :show-text="false" />
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn icon v-allowed="'approve_member'" @click="approveMember(item, false)">
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                  <v-btn icon v-allowed="'approve_member'" @click="rejectMember(item, false)">
                    <v-icon>mdi-minus-circle-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
            <v-card v-else>
              <v-list v-if="pending && pending.length > 0">
                <template v-for="(m, index) in pending">
                  <v-list-item :key="'pending_member_' + m._id">
                    <v-list-item-avatar>
                      <member-avatar :status="m.lastPaymentStatus" :image="m.userImageSmall ? m.userImageSmall : m.userImage
                        " size="40"></member-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content class="text-left">
                      <v-list-item-title>{{ m.displayName }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon v-allowed="'approve_member'" title="Approve"
                                @click="approveMember(m, false)">mdi-plus-circle-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon title="Reject" @click="rejectMember(m, false)"
                                v-allowed="'reject_member'">mdi-minus-circle-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < pending.length" :key="'pending_member_index_' + index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="'rejected'">
            <v-card>
              <v-data-table outlined v-if="!isSmallerDisplay()" v-model="selectedItems" item-key="_id"
                :headers="headersRejected" show-select :items="rejected" class="elevation-1"
                :no-data-text="$t('message.no_data')" :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                  <v-card-actions class="ml-2">
                    <v-checkbox hide-details
                      :label="$t('message.select_all') + ' (' + $t('message.members_selected', [selectedItems.length]) + ')'"
                      @change="selectAll('rejected')"></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-menu elevation="0" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn outlined small elevation="0" :block="isSmallerDisplay()" color="primary" v-on="on"
                          slot="activator" bottom>
                          <v-icon size="20" class="mr-1">mdi-dots-vertical</v-icon>
                          {{ $t("message.actions") }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item :disabled="selectedItems.length == 0">
                          <v-list-item-title @click="openSendEmailDialog()" class="clickable">
                            <v-icon class="mr-1">mdi-email-fast-outline</v-icon>
                            <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{ $t("message.send_emails")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!isSmallerDisplay()">
                          <v-list-item-title @click="getRejectedCSV()" class=" clickable">
                            <v-icon class="mr-1">mdi-cloud-download-outline</v-icon>
                            <span>{{ $t("message.download_list")
                              }}</span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.avatar="{ item }">
                  <div class="text-xs-center clickable" @click="goToRejected(item)">
                    <member-avatar :image="item.userImageSmall
                      ? item.userImageSmall
                      : item.userImage
                      " size="40"></member-avatar>
                  </div>
                </template>
                <template v-slot:item.displayName="{ item }">
                  <span @click="goToRejected(item)" class="mr-1">{{ item.displayName }}</span>
                  <country-display :country-code="item.nationality" />
                </template>
                <template v-slot:item.belt="{ item }">
                  <belt-display :belt="item.belt" :show-text="false" />
                </template>
                <template v-slot:item.removedDate="{ item }">
                  {{ item.removedDate ? $d(new Date(item.removedDate), "month_day_year", $i18n.locale) : '' }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn icon v-allowed="'approve_member'" @click="permnanentlyRemove(item)">
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                  <v-btn icon v-allowed="'approve_member'" @click="approveMember(item, true)">
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
              <v-list v-else>
                <template v-for="(m, index) in rejected">
                  <v-list-item :key="'rejected_' + m._id">
                    <v-list-item-content class="text-left">
                      <v-list-item-title>
                        <member-avatar :image="m.userImageSmall
                          ? m.userImageSmall : m.userImage" size="25"></member-avatar><span class="ml-1">{{
                            m.displayName }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <belt-display :belt="m.belt" :show-text="false" size="10" />
                        <country-display :country-code="m.nationality" class="ml-2" />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon v-allowed="'approve_member'" title="Approve"
                                @click="approveMember(m, false)">mdi-plus-circle-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon title="Reject" @click="permnanentlyRemove(m)"
                                v-allowed="'reject_member'">mdi-minus-circle-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < pending.length" :key="'rejected_members_index_' + index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
    <v-dialog v-model="sendEmailsDialog" max-width="90%">
      <v-card class="text-xs-left" outlined>
        <v-card-title>
          <span style="margin-right: 5px">{{ $t("message.send_email_to") }}:</span>
          <span>
            <b>{{ selectedItems ? selectedItems.length : 0 }}
              {{ $t("message.people") }}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-select item-text="name" item-value="_id" outlined dense :clearable="true" v-model="selectedEmailTemplate"
            @change="selectEmailTemplate" :label="$t('message.select_email_template')" :items="emailTemplates">
          </v-select>
        </v-card-text>
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.subject')" v-model="subject"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-combobox v-model="customEmails" :label="$t('message.custom_email_addresses')"
            :hint="$t('message.custom_emails_hint')" persistent-hint chips multiple outlined dense deletable-chips
            small-chips :error-messages="emailErrors" @input="validateEmails">
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close small
                :color="isValidEmail(data.item) ? 'secondary' : 'error'" dark @click="data.select"
                @click:close="removeEmail(data.item)">
                {{ data.item }}
              </v-chip>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-text>
          <div class="supporting-text" style="margin-left:5px">{{ $t("message.only_one_image") }}</div>
          <div style="overflow-y: auto">
            <VueEditor :style="'background-color:white;color:black'" v-model="editor" :editor-toolbar="editorToolbar" />
          </div>
          <div class="pt-0 pb-0 mb-0 mt-0">
            <div class="text-caption pa-0">{{ $t("message.email_tokens_explained") }}</div>
            <v-select outlined dense @change="copyToken" :label="$t('message.select_token_copy')"
              :items="availableTokens">
            </v-select>
          </div>
        </v-card-text>
        <v-card-text v-if="processingImages" class="p1-0 pr-0 text-center">
          <v-progress-linear :value="processingImagesProgress" :query="true" color="success" height="20"
            buffer-value="0" stream>
            <template v-slot:default="{ }">
              <span class="white--text">{{ $t("message.processing_images") }}</span>
            </template>
          </v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="sendingEmails" small elevation="0" color="primary"
            :disabled="sendingEmails || !subject" @click="sendEmailToMembers()">
            {{ $t("message.send") }}
          </v-btn>
          <v-btn class="outlined-btn" small elevation="0" @click="closeSendEmailDialog()">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendNotiDialog" max-width="90%">
      <v-card class="text-xs-left" outlined>
        <v-card-title>
          <span style="margin-right: 5px">{{ $t("message.send_mobilenotifications_to") }}:</span>
          <span v-if="selectedMember">
            <b>{{ selectedMember.fName }} {{ selectedMember.lName }}</b>
          </span>
          <span v-else>
            <b>{{ selectedItems ? selectedItems.length : 0 }}
              {{ $t("message.people") }}</b>
          </span>
        </v-card-title>
        <v-card-title>
          <v-text-field outlined dense maxlength="50" :label="$t('message.subject')" v-model="subject"></v-text-field>
        </v-card-title>
        <div class="px-6">
          <v-textarea outlined v-model="notificationContents" rows="5" maxlength="250"></v-textarea>
          <span class="supporting-text">{{ $t('message.mobile_notification_explained') }}</span>
        </div>
        <v-card-actions class="mt-3">
          <v-btn outlined elevation="0" color="primary" @click="sendNotificationToMembers()">{{
            $t("message.send")
            }}</v-btn>
          <v-btn elevation="0" @click="closeSendNotiDialog()">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendDocuDialog" max-width="80%">
      <v-card class="text-xs-left" outlined>
        <v-card-title>
          <span>
            <b>{{ $t("message.send_document") }}:
              {{ selectedItems ? selectedItems.length : 0 }}
              {{ $t("message.members") }}</b>
          </span>
        </v-card-title>
        <v-card-title>
          <v-autocomplete @input="
            (event) => {
              $emit('input', event);
            }
          " v-model="selectedDocument" :items="documentTemplates" item-text="text"
            :label="$t('message.select_document')" item-value="value" clearable outlined dense></v-autocomplete>
        </v-card-title>
        <v-card-title>
          <v-autocomplete v-model="selectedPackage" :items="packages" item-text="name"
            :label="$t('message.select_package')" item-value="_id" clearable outlined dense></v-autocomplete>
        </v-card-title>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="sendDocumentToMembers()">{{
            $t("message.send")
            }}</v-btn>
          <v-btn elevation="0" @click="sendDocuDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignSyllabusDialog" max-width="80%">
      <v-card class="text-xs-left" outlined>
        <v-card-title>
          <span>
            <b>{{ $t("message.assign_syllabus") }}:
              {{ selectedItems ? selectedItems.length : 0 }}
              {{ $t("message.members") }}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="selectedSyllabus" :items="syllabusTemplates" item-text="text"
            :label="$t('message.select_syllabus')" @input="getSyllabusTemplateLevels" item-value="value" clearable
            outlined dense></v-autocomplete>
        </v-card-text>
        <v-card-text v-if="syllabusTemplateLevels && syllabusTemplateLevels.length > 0">
          <v-select v-model="selectedSyllabusLevel" :items="syllabusTemplateLevels" item-text="text"
            :label="$t('message.select_level')" item-value="text" clearable outlined dense></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="assignSyllabusToMembers()">{{
            $t("message.assign")
            }}</v-btn>
          <v-btn elevation="0" @click="assignSyllabusDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkCheckinDialog" max-width="90%">
      <v-card class="text-xs-left" outlined>
        <v-card-title>
          <span>
            {{ $t("message.bulk_checkin") }}:
            {{ selectedItems ? selectedItems.length : 0 }}
            {{ $t("message.members") }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="selectedCheckinClass" :items="availableCheckinClasses" item-text="text"
            :label="$t('message.pick_class')" item-value="value" clearable outlined dense></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="processBulkCheckin()">{{
            $t("message.confirm")
            }}</v-btn>
          <v-btn elevation="0" @click="closeBulkCheckinDialog()">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="codeDialog" max-width="800">
      <v-card style class="text-xs-left" outlined>
        <div style>
          <v-text-field single-line outlined dense class="code-input mt-6 mx-6" v-mask="mask" v-model="memberCode">
          </v-text-field>
        </div>
        <div v-if="suggestionMessage" class="warn-message">
          {{ suggestionMessage }}
        </div>
        <v-card-actions>
          <v-btn outlined v-if="selectedMember && !selectedMember.code" color="primary" @click="assignCode()">{{
            $t("message.assign")
            }}</v-btn>
          <v-btn outlined elevation="0" v-if="selectedMember && selectedMember.code" color="primary"
            @click="updateCode()">{{
              $t("message.update")
            }}</v-btn>
          <v-btn elevation="0" class="outlined-btn" @click="closeUserCodeDialog()">{{
            $t("message.close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tagsDialog" max-width="90%">
      <v-card v-if="availableTags" outlined>
        <v-card-title>
          <h3>{{ $t("message.member_labels") }}</h3>
        </v-card-title>
        <div class="mx-6">
          <tags-combo v-if="availableTags" v-model="selectedTags" :label="''" :items="availableTags"></tags-combo>
        </div>
        <div>
          <v-radio-group v-model="editTagsAction">
            <v-radio :label="$t('message.add')" :value="'add'"></v-radio>
            <v-radio :label="$t('message.remove')" :value="'remove'"></v-radio>
          </v-radio-group>
        </div>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="updateMembersTags()">{{ $t("message.update") }}</v-btn>
          <v-btn elevation="0" @click="closeTagsDialog()">{{
            $t("message.close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="socialPostDialog" max-width="90%">
      <v-card v-if="socialPost" class="pa-2" outlined>
        <v-card-text v-if="socialPost.member" class="mt-6">
          <h2 class="mb-2">{{ $t('message.member_shoutout') }}</h2>
          <div class="supporting-text">{{ $t('message.member_shoutout_explained') }}</div>
        </v-card-text>
        <v-card-text v-else>
          <h3>{{ $t('message.social_post') }}</h3>
          <div class="supporting-text">{{ $t('message.social_post_explained') }}</div>
        </v-card-text>
        <v-card-text>
          <div v-if="socialPost.member" class="mb-4">
            <member-avatar v-if="socialPost.member.userImageSmall" :image="socialPost.member.userImageSmall" size="25"
              class="mr-2">
            </member-avatar>
            <span>{{ socialPost.member.displayName }}</span>
          </div>
          <v-textarea
            :label="$t('message.contents') + (socialPost.member ? ' (' + $t('message.optional').toLowerCase() + ')' : '')"
            outlined v-model="socialPost.contents" rows="3" maxlength="250"></v-textarea>
          <div class="supporting-text">
            {{ $t("message.you_can_delete_in_social") }}
          </div>
        </v-card-text>
        <v-card-text v-if="createPoll">
          <v-flex xs12>
            <v-card class="pa-2" v-if="poll">
              <v-card-title style="margin-bottom:-25px">
                <v-icon class="mr-1">mdi-chart-box-outline</v-icon>{{ $t('message.poll') }}
              </v-card-title>
              <v-card-text>
                <v-text-field outlined dense v-model="poll.question" :label="$t('message.question')" maxlength="60">
                </v-text-field>
              </v-card-text>
              <v-card-text style="margin-top:-35px">
                <v-text-field :key="'poll_answer_' + index" v-for="(i, index) in poll.answers"
                  v-model="poll.answers[index]" :label="$t('message.answer') + ' ' + (index + 1)" maxlength="40"
                  outlined dense></v-text-field>
              </v-card-text>
              <v-card-actions class="pa-1" v-if="poll.question && poll.answers.length < 5">
                <v-btn class="elevation-0" color="secondary" small @click="addPollAnswer()">
                  <v-icon class="mr-1">mdi-mdi-plus-circle-outline</v-icon>
                  {{ $t('message.answer') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn class="elevation-0" v-if="!socialPost.member" @click="showOptions('poll')" fab small>
            <ChartSquareBarIcon></ChartSquareBarIcon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" small elevation="0" @click="submitSocialPost()">{{ $t("message.share")
            }}</v-btn>
          <v-btn small elevation="0" @click="closeSocialPostDialog()">{{
            $t("message.close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newUserDialog" max-width="90%">
      <div class="elevation-5" outlined>
        <v-card>
          <v-card-text>
            <h2 class="ml-4 mt-4">{{ $t('message.add_member') }}</h2>
            <div class="pl-4 pr-4 pt-2 pb-2">
              <v-form v-if="newUser" v-model="valid" ref="form" lazy-validation>
                <v-switch dense style="display:inline-block" :label="$t('message.is_minor')" v-model="newUser.isMinor">
                </v-switch>
                <v-text-field :loading="checkingEmail" :rules="emailRules" @keyup="checkExistingUser(newUser)"
                  label="Email" v-model="newUser.email" required outlined dense>
                </v-text-field>
                <div v-if="newUser.isVisitor" class="primary--text">
                  <v-icon class="mr-1">mdi-information-outline</v-icon>
                  {{ $t('message.already_visitor') }}
                </div>
                <div v-else-if="newUser.isProspect" class="primary--text">
                  <v-icon class="mr-1">mdi-information-outline</v-icon>{{ $t('message.already_prospect') }}
                </div>
                <div v-if="!existingNewUser || newUser.isMinor">
                  <v-switch dense :label="$t('message.not_bjj_user')" v-model="newUser.notBjjUser"></v-switch>
                  <v-icon v-if="newUser.isMinor" :color="themeColor('primary')"
                    class="ml-2 mb-2">mdi-baby-face-outline</v-icon>
                  <v-icon v-else-if="newUser.notBjjUser" :color="themeColor('primary')"
                    class="ml-2 mb-2">mdi-account-remove-outline</v-icon>
                  <v-text-field :label="$t('message.first_name')" v-model="newUser.fName" autocomplete="false" required
                    outlined dense></v-text-field>
                  <v-text-field :label="$t('message.last_name')" v-model="newUser.lName" required outlined dense>
                  </v-text-field>
                  <gender-select :icon="false" v-model="newUser.gender"
                    v-show="!newUser.existing || !newUser.existing.gender" />
                  <v-text-field type="password" :label="$t('message.password')" v-model="newUser.password"
                    autocomplete="new-password" required outlined dense
                    v-show="!newUser.existing && !newUser.isMinor"></v-text-field>
                  <belts-select v-if="!newUser.notBjjUser" v-model="newUser.belt"
                    v-show="!newUser.existing || !newUser.existing.belt" />
                  <v-card-text class="mt-0 pl-0 pt-0">
                    <div class="text-subtitle-2">{{ $t('message.birthday') }}</div>
                    <date-picker :show-time="false" v-model="newUserDob" :past-event="true">
                    </date-picker>
                  </v-card-text>
                  <countries-select v-model="newUser.nationality"
                    v-show="!newUser.existing || !newUser.existing.nationality" />
                  <v-switch :disabled="newUser.isMinor" :label="$t('message.old_enough')" v-model="newUser.ageMin">
                  </v-switch>
                </div>
                <div v-else>
                  <div v-if="existingNewUser.alreadyMember" class="error--text">{{ $t("message.already_member") }}</div>
                  <div v-else class="primary--text">{{ $t("message.existing_bjjlink_user") }}</div>
                  <v-list>
                    <v-list-item>
                      <v-list-item-avatar v-if="existingNewUser.image">
                        <ImageDisplay :src="existingNewUser.image" />
                      </v-list-item-avatar>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>
                          {{ existingNewUser.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ existingNewUser.academyName }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
                <div v-html="error" class="registration-error"></div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions class="ml-6 mb-4">
            <v-btn outlined v-if="existingNewUser && !newUser.isMinor" small elevation="0" @click="registerExistingUser"
              color="primary" :disabled="existingNewUser.alreadyMember" :loading="registring">
              {{ $t("message.add_existing_user") }}
            </v-btn>
            <v-btn outlined v-else small elevation="0" @click="register" color="primary" :disabled="!newUserReady()"
              :loading="registring">
              {{ $t("message.add_member") }}
            </v-btn>
            <v-btn small elevation="0" @click="newUserDialog = false; newUser = { nationality: academyCountry }">
              <span>{{ $t("message.close") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="initMessagesThreadDialog" max-width="90%">
      <v-card outlined>
        <v-card-text>
          {{ $t('message.init_academy_messages_explained') }}
        </v-card-text>
        <v-card-text>
          <v-textarea height="3" filled :placeholder="$t('message.first_message_contents')"
            v-model="messageThreadContents"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" small @click="initMessagesThread()">
            {{ $t('message.start_messages') }}
          </v-btn>
          <v-btn elevation="0" small @click="initMessagesThreadDialog = false">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="phoneDialog" width="300">
      <v-card outlined v-if="selectedMember">
        <v-card-title>
          {{ selectedMember.displayName }}
        </v-card-title>
        <v-card-text v-if="selectedMember.phone">
          <div class="text-center text-h6 mb-2">
            {{ selectedMember.phone }}
          </div>
          <div class="mt-1">
            <v-btn elevation="0" color="primary" outlined block>
              <a style="text-decoration:none" :href="'tel:' + selectedMember.phone">
                <v-icon class="mr-1">mdi-phone-outline</v-icon>
                {{ $t('message.call') }}
              </a>
            </v-btn>
          </div>
          <div>
            <v-btn elevation="0" color="primary" outlined block @click="copyToClipboard(selectedMember.phone)">
              <v-icon class="mr-1">mdi-content-copy</v-icon>
              {{ $t('message.copy') }}
            </v-btn>
          </div>
          <div class="mt-1">
            <v-btn elevation="0" color="primary" outlined block @click="openWhatsApp(selectedMember.whatsapp)">
              <img class="mr-1" width="30" :src="assets('icons/whatsapp.png')" />
              WhatsApp
            </v-btn>
          </div>
        </v-card-text>
        <v-card-text>
          <v-card v-if="selectedMember.hasApp" outlined class="mb-1 text-center">
            <v-icon class="mr-1" color="primary">mdi-cellphone-arrow-down</v-icon>
            {{ selectedMember.hasApp.os }} - {{ selectedMember.hasApp.deviceName }}
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" small @click="phoneDialog = false; selectedMember = null;">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="inviteMemberDialog" max-width="80%">
      <v-card class="pa-2" outlined>
        <v-card-title>
          {{ $t("message.invite_members") }}
        </v-card-title>
        <v-card-text class="invite-link">
          <div class="mb-4">
            {{ $t("message.invite_member_link_explained") }}
          </div>
          <div class="truncate-text">
            <v-icon class="mr-1">mdi-link</v-icon> {{ inviteMemberLink }}
          </div>
        </v-card-text>
        <v-card-actions v-if="!isSmallerDisplay()">
          <v-btn outlined :disabled="!inviteMemberLink" small elevation="0" color="primary"
            @click.stop="copyInviteMemberLink()">
            <v-icon class="mr-1">mdi-content-copy</v-icon>
            {{ $t("message.copy_link") }}
          </v-btn>
          <v-btn :disabled="!inviteMemberLink" small elevation="0" class="outlined-btn"
            @click.stop="inviteMemberDialog = false">{{
              $t("message.close")
            }}</v-btn>
        </v-card-actions>
        <div v-else>
          <v-btn outlined block :disabled="!inviteMemberLink" small elevation="0" color="primary"
            @click.stop="copyInviteMemberLink()">
            <v-icon class="mr-1">mdi-content-copy</v-icon>
            {{ $t("message.copy_link") }}
          </v-btn>
          <v-btn outlined class="mt-1" block :disabled="!inviteMemberLink" small elevation="0" color="primary"
            @click.stop="openQRCode()">
            <v-icon class="mr-1">mdi-qrcode</v-icon>
            {{ $t("message.print_qr_code") }}
          </v-btn>
          <v-btn block :disabled="!inviteMemberLink" small elevation="0" class=" mt-1"
            @click.stop="inviteMemberDialog = false">{{
              $t("message.close")
            }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog class="pa-0" v-model="upcomingBirthdaysDialog" fullscreen hide-overlay
      transition="dialog-bottom-transition">
      <v-card outlined class="pa-0">
        <v-toolbar flat class="opposite--text" color="primary" dense>
          <v-card-title>{{ $t('message.upcoming_birthdays') }}</v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="opposite" icon small @click="upcomingBirthdaysDialog = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="upcomingBirthdays">
          <v-list>
            <template v-for="(i, index) in upcomingBirthdays">
              <v-list-item :key="'upcoming_bdate_' + i._id" @click="goToMember(i._id, i.name)">
                <v-list-item-avatar>
                  <member-avatar :image="i.image" size="40"></member-avatar>
                </v-list-item-avatar>
                <v-list-item-content class="text-left">
                  <v-list-item-title>
                    {{ i.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="i.isBirthday">
                    {{ $d(dateFromStringInTZ(i.dob), "month_day_year", $i18n.locale) }} - {{ $t("message.is_birthday")
                    }} ({{ getAge(i.dob) }})
                    <v-icon class="ml-1" size="20" color="accent">mdi-party-popper</v-icon>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-else>
                    {{ $d(dateFromStringInTZ(i.dob), "month_day_year", $i18n.locale) }} - {{ $t('message.in_x_days',
                      [(getAge(i.dob) + 1), i.daysUntilBirthDate]) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index + 1 < upcomingBirthdays.length" :key="'upcoming_bdate_' + index"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BeltDisplay from "@/components/displays/BeltDisplay.vue";
import CountryDisplay from "@/components/displays/CountryFlagDisplay.vue";
import MemberAvatar from "@/components/displays/MemberAvatar.vue";
import BeltsSelect from "@/components/inputs/BeltsSelect.vue";
import CountriesSelect from "@/components/inputs/CountriesSelect.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import GenderSelect from "@/components/inputs/GenderSelect.vue";
import TagsCombo from "@/components/inputs/TagsCombo.vue";
import TagsSelect from "@/components/inputs/TagsSelect.vue";
import Api from "@/services/Api";
import Api2 from "@/services/Api2";
import { Environment } from "@/services/Environment";
import { mask } from "vue-the-mask";
import { VueEditor } from "vue2-editor";

export default {
  directives: {
    mask,
  },
  components: {
    CountryDisplay,
    BeltDisplay,
    TagsCombo,
    TagsSelect,
    BeltsSelect,
    CountriesSelect,
    MemberAvatar,
    GenderSelect,
    VueEditor,
    DatePicker,
  },
  data() {
    return {
      urlTab: this.$route.params.tabId,
      addMemberParameter: this.$route.query.add_member,
      membersTableSort: this.$route.query.sort_members,
      mask: "##-##-##",
      showPopup: false,
      displayFilters: false,
      datePickerDialog: false,
      registring: false,
      editTagsAction: 'add',
      singleSelect: false,
      initMessagesThreadDialog: false,
      messageThreadContents: null,
      error: null,
      newUserDialog: false,
      loadingMembers: false,
      payingMembers: 0,
      noMembershipMembers: 0,
      freeMembers: 0,
      newUser: {},
      classesMap: {},
      existingNewUser: null,
      inviteMemberLink: null,
      inviteMemberDialog: false,
      isInInfo: false,
      memberTypes: [{ text: this.$t("message.all"), value: 'all' }, { text: this.$t("message.adults_only"), value: 'adults' }, { text: this.$t("message.minors_only"), value: 'minors' }],
      statusTypes: [
        { text: this.$t("message.all"), value: 'all' },
        { text: this.$t("message.assigned_membership"), value: 'with-membership' },
        { text: this.$t("message.assigned_paid_membership"), value: 'paid-membership' },
        { text: this.$t("message.assigned_free_membership"), value: 'free-membership' },
        { text: this.$t("message.no_membership"), value: 'no-membership' }],
      membershipTypes: [{ text: this.$t("message.all"), value: 'all' }],
      valid: true,
      bdateRules: [
        (v) => !!v || this.$t("message.dob_required"),
        (v) =>
          /(19|20)\d\d([- /.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])/.test(
            v
          ) || this.$t("message.dob_format"),
      ],
      packages: [],
      selectedPackage: null,
      selectedDocument: null,
      tagFilter: null,
      minorsFilter: 'all',
      statusFilter: 'all',
      membershipTypeFilter: 'all',
      memberCode: null,
      selectedSyllabus: null,
      selectedSyllabusLevel: null,
      memberPhone: null,
      availableTags: null,
      suggestionMessage: null,
      assignSyllabusDialog: false,
      bulkCheckinDialog: false,
      upcomingBirthdays: null,
      upcomingBirthdaysDialog: null,
      sendingEmails: false,
      editor: null,
      notificationContents: null,
      subject: "",
      customEmails: [],
      emailErrors: [],
      sendDocuDialog: false,
      sendCopy: false,
      sendEmailsDialog: false,
      sendNotiDialog: false,
      codeDialog: false,
      tagsDialog: false,
      selectedMember: null,
      hideCheckinCodes: false,
      selectedMemberTags: null,
      selectedEmailTemplate: null,
      schedule: null,
      selectedTags: null,
      loading: true,
      selectedItems: [],
      documentTemplates: [],
      syllabusTemplates: null,
      syllabusTemplateLevels: null,
      syllabusTemplatesRaw: null,
      availableCheckinClasses: null,
      selectedCheckinClass: null,
      socialPostDialog: false,
      createPoll: false,
      poll: {
        answers: ['', '']
      },
      academyCountry: "US",
      socialPost: null,
      newUserDob: null,
      allSelected: false,
      checkingEmail: false,
      filterTableValue: "",
      activeTab: null,
      phoneDialog: false,
      messagesThread: null,
      members: [],
      filteredMembers: [],
      emailTemplates: [],
      pending: [],
      rejected: [],
      paymentsReady: false,
      processingImages: false,
      processingImagesProgress: 20,
      availableTokens: [
        { text: this.$t("message.user_name"), value: "{USER_NAME}" },
        { text: this.$t("message.academy_name"), value: "{ACADEMY_NAME}" }
      ],
      editorToolbar: this.getEditorToolbar(),
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(\s)*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(\s)*$/.test(
            v
          ) || this.$t("message.invalid_email"),
      ],
      //base64ImgRegex: /data:image\/([a-zA-Z]*);base64,([^\"]*)/g,
      headersPending: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "avatar",
        },
        { text: this.$t("message.name"), value: "displayName" },
        { text: this.$t("message.belt"), value: "belt" },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "actions",
        }
      ],

      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "checkbox",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "avatar",
        },
        { text: this.$t("message.name"), value: "displayName" },
        { text: this.$t("message.joined_date"), value: "joined" },
        { text: this.$t("message.dob"), value: "dob" },
        {
          text: this.$t("message.membership"),
          value: "lastPaymentStatus",
        },
        {
          text: this.$t("message.progress"),
          value: "curriculumProgress",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "actions",
        },
      ],

      headersRejected: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "avatar",
        },
        { text: this.$t("message.name"), value: "displayName" },
        { text: this.$t("message.belt"), value: "belt" },
        { text: this.$t("message.removed_date"), value: "removedDate" },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "actions",
        }
      ],
    };
  },
  mounted() {
    if (this.urlTab) {
      try {
        const n = new Number(this.urlTab);
        this.activeTab = n.valueOf();
      } catch (err) {
        console.log('Invalid tab: ', this.urlTab)
      }
    }
  },
  created() {
    this.loading = true;
    if (this.addMemberParameter == 'true')
      this.newUserDialog = true;
    if (this.$store.state.managedAcademy) {
      this.getAvailableTags();
      this.getMembers();
      this.syncMembers();
      this.getSyllabusTemplates();
      this.getDocumentPackages();
      this.checkAcademyStatus();
      this.loadCheckinClasses();
      Api2()
        .get("admins/academy/" + this.$store.state.selectedAcademy)
        .then((response) => {
          if (response && response.data) {
            if (response.data.configuration && response.data.configuration.altTabletCheckin)
              this.hideCheckinCodes = true;
            this.inviteMemberLink = this.generateInviteMemberLink(response.data.name);
            this.academyCountry = response.data.city && response.data.city.country ? response.data.city.country : "US";
            this.paymentsReady =
              response.data.paymentsReady && response.data.stripeAccountId;
          }
        });
      this.updateNotificationsCount();
      Api2()
        .get(
          "documents/academy/" + this.$store.state.managedAcademy + "/templates?active=true"
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            const templates = data;
            if (templates) {
              for (const d of templates) {
                const text = d.name;
                const value = d._id;
                if (d.active)
                  this.documentTemplates.push({ text: text, value: value });
              }
            }
          }
        });
      //Message Thread available?
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/messages/thread")
        .then((response) => {
          const data = response.data;
          if (data && data.messagesThread) {
            this.messagesThread = data.messagesThread;
          }
        });
    }
  },
  watch: {
    '$route'(to) {
      this.activeTab = to.params.tabId;
    },
    filterTableValue: {
      handler: function (newValue) {
        this.filterTable(newValue);
      },
    },
    tagFilter: {
      handler: function () {
        this.filterTableByTag();
      },
    },
    minorsFilter: {
      handler: function () {
        this.filterTableByMinors();
      },
    },
    statusFilter: {
      handler: function () {
        this.filterTableByStatus();
      },
    },
    membershipTypeFilter: {
      handler: function () {
        this.filterTableByMembership();
      },
    },
    selectedTags: {
      handler: function (newValue) {
        this.selectedTags = newValue;
      },
    },
  },
  methods: {
    copyPhone(phone) {
      if (phone)
        this.copyToClipboard(phone);
    },
    goToRejected(item) {
      this.goToVisitor(item.visitorId);
    },
    membersSort(items, index, isDesc) {
      if (index[0]) {
        const column = index[0];
        if (column != this.membersTableSort) {
          this.navigateTo({
            name: "memberstab",
            params: { tabId: 0 },
            query: { sort_members: index[0] + '|' + isDesc[0] }
          });
        }
      }
      items.sort((a, b) => {
        if (index[0] == 'joined' || index[0] == 'dob') {
          const aDate = a == '' ? null : new Date(a[index]);
          const bDate = b == '' ? null : new Date(b[index]);
          const ascending = !isDesc[0];
          if (aDate === null && bDate !== null) {
            return ascending ? -1 : 1; // `a` is null, `b` is not null
          } else if (aDate !== null && bDate === null) {
            return ascending ? 1 : -1; // `a` is not null, `b` is null
          } else if (aDate === null && bDate === null) {
            return 0; // both are null, keep their order
          } else {
            // both are not null, compare Date objects
            return ascending ? aDate - bDate : bDate - aDate;
          }
        } else if (index[0] == 'curriculumProgress') {
          if (!isDesc[0])
            return a[index] - b[index];
          else
            return b[index] - a[index];
        } else if (index[0] == 'lastPaymentStatus') {
          const priority = {
            active: 1,
            completed: 1,
            trialing: 2,
            paused: 3,
            past_due: 4,
            pending_payment: 5,
            expired: 6
          };

          const aVal = priority[a[index]] ?? 7;
          const bVal = priority[b[index]] ?? 7;

          return !isDesc[0] ? aVal - bVal : bVal - aVal;
        } else {
          if (typeof a[index] !== 'undefined') {
            if (!isDesc[0]) {
              return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
            }
            else {
              return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
            }
          }
        }
      });
      return items;
    },
    permnanentlyRemove(m) {
      Api()
        .delete(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/members/rejected/" + m._id
        )
        .then((response) => {
          if (response) {
            this.getMembers()
          }
        })
        .catch(() => {
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    selectEmailTemplate(v) {
      if (v) {
        Api2()
          .get(
            "documents/academy/" +
            this.$store.state.managedAcademy +
            "/email/templates/" +
            v
          )
          .then((response) => {
            if (response) {
              const template = response.data.template;
              this.editor = template.contents;
              this.subject = template.subject;
            }
          })
          .catch(() => {
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      }
    },
    getEmailTemplates() {
      Api2()
        .get(
          "documents/academy/" + this.$store.state.managedAcademy + "/email/templates?archived=false"
        )
        .then((response) => {
          if (response) {
            if (response.data.templates && response.data.templates.length > 0)
              this.emailTemplates = response.data.templates;
          }
        });
    },
    processBulkCheckin() {
      const checkinData = this.getManualCheckinClassData(this.schedule, this.selectedCheckinClass, this.classesMap);
      if (checkinData) {
        let members = [];
        if (this.selectedItems) {
          for (const r of this.selectedItems) {
            members.push(r._id);
          }
        }
        if (members.length == 0) {
          this.showAlert("error", this.$t("message.error_generic"));
          return;
        }
        let className = checkinData.class.name;
        let classDay = checkinData.class.day;
        let scheduleClassId = checkinData.class._id;
        const checkinTime = checkinData.checkinTime;
        const professorId = checkinData.professorUser;
        const assistantProfessors = checkinData.assistantProfessors;
        const data = {
          date: this.dateCheckin,
          member: this.selectedCheckinMember,
          dayOfMonth: checkinTime.getDate(),
          members: members,
          className: className,
          classDay: classDay,
          startTime: checkinData.class.start,
          checkinTime: checkinTime,
          yearAtCity: checkinTime.getFullYear(),
          monthAtCity: checkinTime.getMonth() + 1,
          academyClassId: null,
          scheduleClassId: scheduleClassId,
          professor: professorId,
          assistantProfessors: assistantProfessors,
        };
        Api()
          .post(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/checkin/member/bulk",
            data
          )
          .then((response) => {
            if (response) this.showAlert("success", this.$t("message.success"));
            this.closeBulkCheckinDialog();
          }).catch((e) => {
            if (e)
              this.showAlert("error", this.$t("message.error_generic"));
          });
      }


    },
    loadCheckinClasses() {
      Api2()
        .get("admins/academy/" + this.$store.state.selectedAcademy)
        .then((response) => {
          let schedule = response.data.schedule;
          this.schedule = schedule;
          let tmp = [];
          for (const d in schedule) {
            for (const c of schedule[d]) {
              var text =
                this.$t("message." + d) + ": " + c.name + " (" + this.numberToTime(c.start) + ")";
              const value = c._id;
              tmp.push({ value: value, text: text, professor: c.professorUser, day: c.day, start: c.start });
            }
          }
          if (tmp.length > 0) {
            const todayClasses = this.getTodaySchedule(tmp);
            if (todayClasses && todayClasses.length) {
              const todaysSchedule = this.$t("message.todays_schedule");
              const schedule = this.$t("message.schedule");
              this.availableCheckinClasses = [];
              this.availableCheckinClasses.push({ header: todaysSchedule });
              this.availableCheckinClasses = this.availableCheckinClasses.concat(todayClasses);
              this.availableCheckinClasses.push({ header: schedule });
              this.availableCheckinClasses = this.availableCheckinClasses.concat(tmp);
            } else {
              this.availableCheckinClasses = tmp;
            }
          }
          //Now add the extra events
          this.classesMap = {};
          Api2()
            .get("calendar/admin/academy/" + this.$store.state.managedAcademy + "/checkins/events")
            .then((response) => {
              const data = response.data;
              if (data) {
                for (const academyClass of data.events) {
                  const text = academyClass.title + " (" + this.$d(new Date(academyClass.date), "month_day", this.$i18n.locale) + ")";
                  this.availableCheckinClasses.push({ value: academyClass.id, text: text, professor: academyClass.professorUser });
                  this.classesMap[academyClass.id] = academyClass;
                }
              }
            })
        });
    },
    goToSellMembership(item) {
      this.navigateTo({
        name: "sellproduct",
        params: { productId: 'membership' },
        query: { userId: item._id },
      });
    },
    copyToken(val) {
      this.copyToClipboard(val);
    },
    copyPublicContactForm() {
      let urlToCopy = 'https://api.bjjlink.com/pub/academy/' + this.$store.state.selectedAcademy + '/contact/form'
      this.copyToClipboard(urlToCopy);
    },
    openQRCode() {
      let buff = new Buffer(this.inviteMemberLink);
      const encodedUrl = buff.toString("base64");
      window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=invite');
    },
    generateInviteMemberLink(academyName) {
      if (this.$store.state.user._id && academyName)
        return 'https://connect.bjjlink.com/register?i=' + btoa(this.$store.state.user._id) + '&a=' +
          btoa(this.$store.state.selectedAcademy) +
          '&an=' + btoa(academyName.replace(/[^a-zA-Z ]/g, ""));
      else
        return null;
    },
    initMessagesThread() {
      if (this.messageThreadContents && this.messageThreadContents != '') {
        Api()
          .post("admins/academy/" + this.$store.state.managedAcademy + "/messages/thread",
            { contents: this.messageThreadContents })
          .then((response) => {
            if (response.data) {
              this.messagesThread = response.data.messagesThread;
              this.initMessagesThreadDialog = false;
              this.showAlert("success", this.$t("message.success"), this.$t("message.messgaes_thread_created"), 8000);
            }
          });
      } else {
        this.showAlert("error", this.$t("message.fill_all_params"));
      }
    },
    goToMessagesThread() {
      window.open("https://connect.bjjlink.com/secure/inbox");
    },
    clickTab(tab) {
      if (tab != this.activeTab) {
        this.selectedItems = [];
        this.navigateTo({
          name: "memberstab",
          params: { tabId: tab },
        });
      }
    },
    getDocumentPackages() {
      Api2()
        .get(
          "documents/academy/" + this.$store.state.managedAcademy + "/packages"
        )
        .then((response) => {
          if (response.data) {
            this.packages = response.data.packages;
          }
        });
    },
    addPollAnswer() {
      if (this.poll && this.poll.answers && this.poll.answers.length < 5) {
        this.poll.answers.push('');
      }
    },
    showOptions(option) {
      if (option == 'poll')
        this.createPoll = true;
    },
    displaySocialPostDialog(member) {
      this.socialPost = {
        member: member
      }
      this.selectedMember = member;
      this.socialPostDialog = true;
    },
    displayPhoneDialog(member) {
      this.selectedMember = member;
      this.phoneDialog = true;
    },
    closeSocialPostDialog() {
      this.socialPostDialog = false;
      this.socialPost = null;
      this.selectedMember = null;
    },
    submitSocialPost() {
      if (this.socialPost) {
        if (!this.socialPost.member && !this.socialPost.contents) {
          this.showAlert("error", "Oops!", this.$t("message.fill_all_params"));
          return;
        }
        if (this.socialPost.member)
          this.socialPost.member = this.socialPost.member._id;
        if (this.poll && this.poll.answers.length > 1)
          this.socialPost.poll = this.poll;
        Api()
          .post(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/posts/social", this.socialPost
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.socialPostDialog = false;
              this.socialPost = null;
              this.selectedMember = null;
              this.showAlert("success", this.$t("message.success"));
              this.poll = {
                answers: ['', '']
              };
              this.createPoll = false;
            }
          })
          .catch((e) => {
            this.loading = false;
            if (e)
              this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      }
    },
    getSyllabusTemplates() {
      Api2()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/templates")
        .then(response => {
          if (response) {
            if (response.data.templates && response.data.templates.length) {
              this.syllabusTemplates = [];
              this.syllabusTemplatesRaw = response.data.templates;
              for (const t of response.data.templates)
                this.syllabusTemplates.push({ text: t.name, value: t._id, useBelts: t.useBelts });
            }
          }
        });
    },
    getSyllabusTemplateLevels(templateId) {
      this.syllabusTemplateLevels = [];
      for (const i of this.syllabusTemplatesRaw) {
        if (i._id == templateId && i.levels && i.levels.length > 0) {
          for (const level of i.levels)
            this.syllabusTemplateLevels.push({
              text: level.level, value: level._id
            });
        }
      }
    },
    syncMembers() {
      Api2()
        .get(
          "admins/academy/" + this.$store.state.managedAcademy + "/sync/members"
        )
        .then((response) => {
          if (response && response.data.updated > 0) {
            this.getMembers();
          }
        });
    },
    getMembers() {
      this.loadingMembers = true;
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.selectedAcademy +
          "/members?get_subscriptions=true&get_curriculum_instances=true"
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            if (data.approved) {
              this.members = data.approved;
              if (data.memberships && data.memberships.length)
                this.membershipTypes = this.membershipTypes.concat(data.memberships);
              const phoneCode = data.phoneCode;
              this.payingMembers = data.payingMembers;
              this.freeMembers = data.freeMembersCount;
              this.noMembershipMembers = data.noMembershipCount
              let upcomingBirthdays = [];
              for (const m of this.members) {
                const daysUntilBirthDate = this.daysUntilBirthDate(m.dob);
                m.isBirthday = daysUntilBirthDate == 0 ? true : false;
                m.whatsapp = this.getWhatsAppLink(phoneCode, m.phone);
                m.transactionIcon = this.getTransactionPaymentTypeIcon(m);
                if (daysUntilBirthDate < 0 && daysUntilBirthDate > -3)
                  m.daysUntilBirthDate = daysUntilBirthDate;
                if (m.isBirthday || (daysUntilBirthDate > -30 && daysUntilBirthDate < 0)) {
                  upcomingBirthdays.push({
                    _id: m._id,
                    name: m.displayName,
                    image: m.userImage,
                    dob: m.dob,
                    isBirthday: m.isBirthday,
                    daysUntilBirthDate: Math.abs(daysUntilBirthDate)
                  });
                }
              }
              if (upcomingBirthdays.length > 0) {
                this.upcomingBirthdays = upcomingBirthdays.sort(function (a, b) {
                  return a.daysUntilBirthDate - b.daysUntilBirthDate;
                });
              }
              this.filteredMembers = this.members;
              if (this.membersTableSort) {
                const split = this.membersTableSort.split('|');
                const columnName = split[0];
                const isDesc = split[1] == 'true' ? true : false;
                this.membersSort(this.filteredMembers, [columnName], [isDesc])
              }
            }
            //this.selectedMember = this.members[0];
            this.rejected = data.rejected;
            this.pending = data.pending;
            this.loadingMembers = false;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    getMembersCSV() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/members/export/csv"
        )
        .then((response) => {
          let blob = new Blob([response.data], { type: "text/csv" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Members_" + new Date().toISOString() + "_" + ".csv";
          link.click();
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    assignSyllabusToMembers() {
      var recipients = [];
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          recipients.push(r._id);
        }
      }
      if (recipients.length > 0 && this.selectedSyllabus) {
        Api()
          .post(
            "syllabus/academy/" +
            this.$store.state.managedAcademy +
            "/templates/" +
            this.selectedSyllabus + "/assign",
            { users: recipients, level: this.selectedSyllabusLevel }
          )
          .then((response) => {
            if (response) {
              this.showAlert(
                "success",
                this.$t("message.assigned_to_members", [response.data.total])
              );
              this.assignSyllabusDialog = false;
              this.selectedSyllabusLevel = null;
              this.selectedSyllabus = null;
              this.syllabusTemplateLevels = null;
              this.getMembers();
            }
          })
          .catch((e) => {
            if (e)
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          });
      } else {
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    sendDocumentToMembers() {
      var recipients = [];
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          recipients.push(r._id);
        }
      }
      if (recipients.length > 0 && (this.selectedDocument || this.selectedPackage)) {
        let objectId = this.selectedDocument;
        let objectType = 'document';
        if (this.selectedPackage) {
          objectId = this.selectedPackage;
          objectType = 'package';
        }
        Api()
          .post(
            "documents/academy/" +
            this.$store.state.managedAcademy +
            "/templates/send/" +
            objectId,
            { users: recipients, allowResend: true, objectType: objectType }
          )
          .then((response) => {
            if (response) {
              this.showAlert(
                "success",
                this.$t("message.sent_docs_to_members", [response.data.totalMembers, response.data.totalDocuments])
              );
              this.sendDocuDialog = false;
            }
          })
          .catch((e) => {
            if (e)
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          });
      } else {
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    assignSubscription(id) {
      this.navigateTo({
        name: "sellproduct",
        query: { userId: id },
        params: { productId: "membership" },
      });
    },
    getStatusColor(status) {
      return this.getTransactionStatusColor(status);
    },
    newUserReady() {
      if (
        this.newUser.fName &&
        this.newUser.lName &&
        this.newUser.email &&
        (this.newUser.password || this.newUser.existing || this.newUser.isMinor) &&
        this.newUser.nationality &&
        (this.newUser.notBjjUser || this.newUser.belt) &&
        (this.newUser.ageMin || this.newUser.isMinor)
      ) {
        return true;
      }
      return false;
    },
    registerExistingUser() {
      if (!this.existingNewUser || !this.existingNewUser._id) {
        this.showAlert("error", this.$t("message.fill_all_params"));
        return;
      } else {
        this.registring = true;
        Api()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/connect/existing/" + this.existingNewUser._id,
          )
          .then((response) => {
            try {
              if (response.data) {
                this.$emit('refresh-search');
                this.loading = false;
                this.registring = false;
                this.newUserDialog = false;
                this.existingNewUser = null;
                this.getMembers();
                //Call the member to trigger creation of stripe data if needed
                if (this.paymentsReady)
                  this.loadNewMember(this.existingNewUser._id);
                else
                  this.newUser = { nationality: this.academyCountry };
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch(() => {
            this.registring = false;
            this.showAlert("error", "Error :(");
          });
      }
    },
    register() {
      try {
        if (this.newUserDob) {
          let d = new Date(this.newUserDob);
          d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0))
          this.newUser.dob = d;
        }
        this.registring = true;
        if (this.newUser.password) {
          let buff = new Buffer(this.newUser.password);
          let base64data = buff.toString("base64");
          this.newUser.password = base64data;
        } else {
          this.newUser.password = this.generatePassword();
          let buff = new Buffer(this.newUser.password);
          let base64data = buff.toString("base64");
          this.newUser.password = base64data;
        }
        this.newUser.academy = this.$store.state.selectedAcademy;
        if (this.newUser.notBjjUser) this.newUser.belt = "white";
        this.newUser.existing = null;
        Api()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/new_member",
            this.newUser
          )
          .then((response) => {
            try {
              if (response.data) {
                this.newUserDialog = false;
                this.registring = false;
                //this.newUser = {};
                const newUser = response.data;
                this.loading = false;
                //Load members again and approve this new member
                if (newUser.isMinor) {
                  this.approveMember(newUser, false);
                  this.selectedMember = newUser;
                } else {
                  this.approveMember(newUser, false);
                }
                this.existingNewUser = null;
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch((e) => {
            this.registring = false;
            if (e.response.status == 409) {
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.already_a_user"),
                9000
              );
            } else if (e.response.data.errorCode == 'invalid_email') {
              this.showAlert(
                "error",
                this.$t("message.invalid_email")
              );
            } else {
              this.showAlert("error", "Oops!", "Error :(");
            }
          });
      } catch (err) {
        console.log(err)
      }

    },
    getAvailableTags() {
      Api2()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/tags")
        .then((response) => {
          if (response.data) {
            this.availableTags = response.data.sort();
          }
        })
        .catch((e) => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    viewMember(id, instanceId, section, crumbName) {
      if (instanceId)
        this.navigateTo({ name: "viewmember", params: { memberid: id }, query: { si: instanceId }, crumbName: crumbName });
      else if (section)
        this.navigateTo({ name: "viewmember", params: { memberid: id }, query: { section: section }, crumbName: crumbName });
      else
        this.navigateTo({ name: "viewmember", params: { memberid: id }, crumbName: crumbName });
    },
    updateMembersTags() {
      let recipients = [];
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          recipients.push(r._id);
        }
      }
      if (recipients.length > 0 && this.selectedTags && this.selectedTags.length > 0) {
        const data = {
          memberIds: recipients,
          action: this.editTagsAction,
          tags: this.selectedTags
        };
        Api()
          .patch(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/members/tags",
            data
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.selectedTags = null;
              this.getAvailableTags();
              this.closeTagsDialog();
              this.showAlert(
                "success",
                this.$t("message.success")
              );
            }
          })
          .catch((e) => {
            this.loading = false;
            if (e)
              this.showAlert("error", "Ops!", this.$t("message.error_generic"));
          });
      }
    },
    clearFilters(clearAll) {
      this.minorsFilter = 'all';
      this.membershipTypeFilter = 'all';
      this.statusFilter = 'all';
      if (clearAll) {
        this.tagFilter = null;
        this.filterTableByTag();
      }
    },
    filterTableByTag() {
      const value = this.tagFilter;
      this.clearFilters();
      this.loading = true;
      if (!value || value == "") {
        this.filteredMembers = this.members;
        this.loading = false;
      } else {
        Api2()
          .get(
            "admins/academy/" +
            this.$store.state.selectedAcademy +
            "/members/tag/" +
            encodeURIComponent(value)
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              //For each member, keep those in our list
              this.filteredMembers = [];
              for (const m of this.members) {
                if (data.indexOf(m._id) >= 0) this.filteredMembers.push(m);
              }
            }
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            if (e)
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          });
      }
    },
    filterTableByMinors() {
      const value = this.minorsFilter;
      this.membershipTypeFilter = 'all';
      this.statusFilter = 'all';
      const list = this.members;
      if (value == 'minors') {
        if (list) {
          let filtered = [];
          for (const m of list) {
            if (m.isMinor)
              filtered.push(m);
          }
          this.filteredMembers = filtered;
        }
      } else if (value == 'adults') {
        if (list) {
          let filtered = [];
          for (const m of list) {
            if (!m.isMinor)
              filtered.push(m);
          }
          this.filteredMembers = filtered;
        }
      } else {
        this.clearFilters(true);
      }
    },
    filterTableByMembership() {
      const value = this.membershipTypeFilter;
      const list = this.members;
      this.minorsFilter = 'all';
      this.statusFilter = 'all';
      if (value && value != 'all') {
        if (list) {
          let filtered = [];
          for (const m of list) {
            if (m.currentMembership == value)
              filtered.push(m);
          }
          this.filteredMembers = filtered;
        }
      } else {
        this.clearFilters(true);
      }
    },
    filterTableByStatus() {
      const value = this.statusFilter;
      this.minorsFilter = 'all';
      this.membershipTypeFilter = 'all';
      const list = this.members;

      if (value == 'with-membership') {
        // Anyone who has a non-pending record
        this.filteredMembers = list.filter(m => m.lastPaymentStatus && m.lastPaymentStatus !== 'pending_payment');

      } else if (value == 'paid-membership') {
        this.filteredMembers = list.filter(m => m.paidMember);

      } else if (value == 'free-membership') {
        // Matches Backend: status exists, not pending, and is free (not paid)
        this.filteredMembers = list.filter(m => m.lastPaymentStatus && m.lastPaymentStatus !== 'pending_payment' && m.freeMembership);

      } else if (value == 'no-membership') {
        // Matches Backend: No status OR status is pending
        this.filteredMembers = list.filter(m => {
          return !m.lastPaymentStatus || m.lastPaymentStatus === 'pending_payment';
        });

      } else {
        this.clearFilters(true);
      }
    },
    filterTable(value) {
      this.clearFilters();
      if (value == "") {
        this.filteredMembers = this.members;
      } else {
        value = value.toLowerCase();
        if (this.members) {
          var filtered = [];
          for (const m of this.members) {
            const displayName = m.fName.toLowerCase() + ' ' + m.lName.toLowerCase();
            if (
              m.fName.toLowerCase().indexOf(value) >= 0 ||
              m.lName.toLowerCase().indexOf(value) >= 0 ||
              displayName.indexOf(value) >= 0
            ) {
              filtered.push(m);
            }
          }
          this.filteredMembers = filtered;
        }
      }
    },
    selectAll: function (type) {
      if (!this.allSelected) {
        this.allSelected = true;
        if (!type || type == 'members') {
          for (let i of this.filteredMembers)
            this.selectedItems.push(i);
        } else {
          for (let i of this.rejected)
            this.selectedItems.push(i);
        }
      } else {
        this.allSelected = false;
        this.selectedItems = [];
      }
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    updateCode() {
      this.assignCode();
    },
    assignCode(id) {
      var memberId = null;
      if (id) memberId = id;
      else memberId = this.selectedMember._id;
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.selectedAcademy +
          "/code/" +
          memberId,
          { code: this.memberCode }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            try {
              for (const m of this.members) {
                if (m._id == memberId) {
                  m.code = this.memberCode;
                  break;
                }
              }
              this.codeDialog = false;
              this.selectedMember = null;
            } catch (e) {
              console.log(e);
            }
          }
        })
        .catch((e) => {
          if (e.response.status === 409) {
            this.showAlert("error", this.$t("message.duplicate_code"));
          } else {
            this.showAlert("error", "Oops!", ":(");
          }
        });
    },
    viewUserCode(member) {
      this.suggestionMessage = null;
      this.codeDialog = true;
      this.selectedMember = member;
      if (member.code) {
        var code = member.code + "";
        code = code.replace(/-/g, "");
        this.memberCode =
          code.charAt(0) +
          code.charAt(1) +
          "-" +
          code.charAt(2) +
          code.charAt(3) +
          "-" +
          code.charAt(4) +
          code.charAt(5);
      } else {
        this.memberCode = null;
        if (member.dob) {
          var newCode = this.toNiceDateCustomFormat(member.dob, "MM-DD-YY");
          this.memberCode = newCode;
          this.suggestionMessage = this.$t("message.code_suggestion") + newCode;
        } else {
          this.suggestionMessage = this.$t("message.nocode_suggestion");
        }
      }
    },
    copyInviteMemberLink() {
      let urlToCopy = this.inviteMemberLink;
      this.copyToClipboard(urlToCopy);
    },
    closeUserCodeDialog() {
      this.codeDialog = false;
      this.selectedMember = null;
    },
    openTagsDialog() {
      if (this.selectedItems && this.selectedItems.length > 0)
        this.tagsDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    closeTagsDialog() {
      this.tagsDialog = false;
      this.selectedMember = null;
    },
    getRejectedCSV() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/export/csv/rejected"
        )
        .then((response) => {
          let blob = new Blob([response.data], { type: "text/csv" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "rejected_" + new Date().toISOString() + "_" + ".csv";
          link.click();
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    approveMember(member, reapprove) {
      let data = { members: [member._id] };
      if (reapprove) data["rejected"] = true;
      Api()
        .post(
          "admins/academy/" + this.$store.state.selectedAcademy + "/approve",
          data
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.getMembers();
            this.newUser = { nationality: this.academyCountry };
            this.$emit('refresh-search');
            if (this.paymentsReady)
              this.loadNewMember(member._id);
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    loadNewMember(id) {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.selectedAcademy +
          "/member/" +
          id
        )
    },
    rejectMember(member, approved) {
      //Add confirmation modal here...
      Api()
        .post(
          "admins/academy/" + this.$store.state.selectedAcademy + "/reject",
          { members: [member._id] }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            var i = 0;
            if (approved) {
              for (const p of this.members) {
                if (p._id == member._id) {
                  this.members.splice(i, 1);
                  break;
                }
                i++;
              }
              this.rejected.unshift(member);
            } else {
              for (const p of this.pending) {
                if (p._id == member._id) {
                  this.pending.splice(i, 1);
                  break;
                }
                i++;
              }
              this.members.unshift(member);
            }
          }
        })
        .catch((e) => {
          if (e) {
            if (e.response.data.message_translation)
              this.showAlert(
                "error",
                this.$t("message." + e.response.data.message_translation),
                null,
                8000
              );
            else
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          }
        });
    },
    reAproveMember(id) {
      console.log("Reapproving: ", id);
    },
    openSendEmailDialog() {
      this.getEmailTemplates();
      if (this.selectedItems && this.selectedItems.length > 0)
        this.sendEmailsDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    openSendNotiDialog() {
      if (this.selectedItems && this.selectedItems.length > 0)
        this.sendNotiDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    openSendDocuDialog() {
      if (this.selectedItems && this.selectedItems.length > 0)
        this.sendDocuDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    openAssignSyllabusDialog() {
      if (this.selectedItems && this.selectedItems.length > 0)
        this.assignSyllabusDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    openBulkCheckinDialog() {
      if (this.selectedItems && this.selectedItems.length > 0)
        this.bulkCheckinDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    closeBulkCheckinDialog() {
      this.bulkCheckinDialog = false;
      this.selectedCheckinClass = null;
    },
    closeSendEmailDialog() {
      this.sendEmailsDialog = false;
      this.selectedMember = null;
      this.sendingEmails = false;
    },
    closeSendNotiDialog() {
      this.sendNotiDialog = false;
      this.selectedMember = null;
    },
    sendNotificationToMembers() {
      var recipients = [];
      var postData = {};
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          recipients.push(r._id);
        }
      }
      if (
        recipients.length > 0 &&
        this.notificationContents &&
        this.notificationContents != "" &&
        this.subject &&
        this.subject != ""
      ) {
        postData.recipients = recipients;
        postData.subject = this.subject;
        postData.contents = this.notificationContents;
        Api()
          .post(
            "admins/academy/" +
            this.$store.state.selectedAcademy +
            "/send/notifications",
            postData
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.showAlert("success", "Oss!", ":)");
              this.sendNotiDialog = false;
              this.selectedMember = null;
              this.selectedItems = [];
              this.subject = "";
              this.notificationContents = null;
              this.filteredMembers = this.members;
            }
          })
          .catch((e) => {
            if (e)
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          });
      } else {
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    async sendEmailToMembers() {
      this.sendingEmails = true;
      this.validateEmails();

      let recipients = [];
      let postData = {};
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          if (r._id) recipients.push(r._id);
        }
      }

      const validCustomEmails = this.customEmails.filter(email => this.isValidEmail(email));

      const hasRecipients = recipients.length > 0 || validCustomEmails.length > 0;

      if (hasRecipients && this.editor != "" && this.subject != "" && this.emailErrors.length === 0) {
        postData.recipients = recipients;
        postData.subject = this.subject;
        postData.sendCopy = this.sendCopy;
        postData.contents = this.editor;
        postData.emailTemplate = this.selectedEmailTemplate;
        postData.bcc = validCustomEmails;

        const regexp = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
        let totalImages = 0;
        const groups = this.findMatches(postData.contents, regexp);
        const replacements = [];

        if (groups.length >= 1) {
          let increaseBy = Math.round((100 - this.processingImagesProgress) / (totalImages + 1));
          this.processingImages = true;
          for (const group of groups) {
            try {
              const formData = new FormData();
              const d = new Date();
              const millis = d.getTime();

              const blob = this.blobFromBase64(group);
              formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.jpg');
              const res = await Api2()
                .post("content/image/admin", formData);
              const data = res.data;
              if (data) {
                replacements.push(data.location);
                this.processingImagesProgress += increaseBy;
              }
            } catch (err) {
              console.log(err);
              this.processingImages = false;
              this.showAlert("error", "Error processing images");
              return;
            }
          }
          this.processingImagesProgress = 100;
          postData.contents = this.replaceMatches(postData.contents, regexp, replacements);
        }
        this.postEmail(postData);
      } else {
        this.sendingEmails = false;
        this.processingImages = false;
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    postEmail(emailData) {
      this.processingImages = false;
      Api()
        .post(
          "admins/v2/academy/" +
          this.$store.state.managedAcademy +
          "/send/emails",
          emailData
        )
        .then((response) => {
          this.showAlert("success", "Oss!", ":)");
          if (response.data) {
            this.sendEmailsDialog = false;
            this.selectedMember = null;
            this.selectedItems = [];
            this.allSelected = false;
            this.selectedItems = [];
            this.sendingEmails = false;
            this.subject = "";
            this.editor = null;
            this.customEmails = [];
            this.emailErrors = [];
            this.selectedEmailTemplate = null;
          }
        })
        .catch((e) => {
          this.sendingEmails = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    validateEmails() {
      this.emailErrors = [];
      const invalidEmails = this.customEmails.filter(email => !this.isValidEmail(email));
      if (invalidEmails.length > 0) {
        this.emailErrors = [`Invalid email(s): ${invalidEmails.join(', ')}`];
      }
    },
    removeEmail(email) {
      const index = this.customEmails.indexOf(email);
      if (index >= 0) {
        this.customEmails.splice(index, 1);
      }
      this.validateEmails();
    },
  },
};
</script>

<style>
.username_popover {
  position: absolute;
  background: #fff;
  color: black;
  border: 1px solid black;
  padding: 10px 20px;
  box-shadow: 0 6px 6px rgba(16, 16, 16, 0.04), 0 6px 6px rgba(0, 0, 0, 0.05);
  z-index: 999;
  min-width: 350px;
  max-width: 350px;
  right: 20px;
  bottom: 80px;
  text-align: center;
}

.disabled-menu {
  color: gray;
}
</style>
